module.exports = __webpack_public_path__ + "static/media/auv.6821a53f.svg";